var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilledClipped262X262 = function SvgFilledClipped262X262(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 352"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 262.793,
    height: 262.793,
    x: -90.781,
    y: -9.798,
    rx: 24.857,
    transform: "rotate(46.625 -90.781 -9.798)"
  })));
};
export default SvgFilledClipped262X262;